module.exports = __webpack_public_path__ + "img/id_02.2bc41f5a.png";